import React, { useState } from "react";
import { Box, MainText, MainTitle } from "app/components/common";
import { ScrollView } from "react-native";
import ActionText from "app/scenes/ActionScreen/ActionText";
import isActionEmpty from "app/utils/isActionEmpty";
import i18n from "@microdoing/shared/i18n";
import selectActionLanguage from "app/utils/selectActionLanguage";
import { useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import { getStepSelected } from "@microdoing/shared/services/userCampaign/selectors";
import selectLanguage from "@microdoing/shared/utils/selectLanguage";
import SocialSheet from "./SocialSheet";
import CommentList from "./CommentList";
import theme from "app/Theme/Theme";

interface IProps {}

const Action = ({}: IProps) => {
  const [isOpenSocialSheet, setIsOpenSocialSheet] = useState(false);

  const stepSelected = useSelector(getStepSelected);
  const language = useSelector(getLanguage);
  const actionTitle = stepSelected?.title;
  const { title, how, why } = stepSelected?.content || {};
  const { rating, numberOfComments = 0, users = [], totalDone } = stepSelected;
  const contentTitle = selectActionLanguage({ text: title, language });
  const contentHow = selectActionLanguage({ text: how, language });
  const contentWhy = selectActionLanguage({ text: why, language });

  const handlePressSocialSheet = () => {
    setIsOpenSocialSheet(!isOpenSocialSheet);
  };

  return (
    <Box flex={1} paddingVertical="xl">
      {!isOpenSocialSheet ? (
        <>
          <MainTitle
            variant="l6-bold"
            marginBottom="s"
            paddingHorizontal="webM"
          >
            {selectLanguage({ text: actionTitle, language }) || `Action`}
          </MainTitle>
          <ScrollView
            style={{ flex: 1, paddingHorizontal: theme.spacing.webM }}
          >
            <Box>
              <ActionText text={contentTitle} />
              {!isActionEmpty(contentWhy) && (
                <Box marginTop="sm">
                  <MainText marginBottom={0} variant="l3-bold">
                    {i18n.t("why")}
                  </MainText>
                  <ActionText text={contentWhy} />
                </Box>
              )}
              {!isActionEmpty(contentHow) && (
                <Box marginTop="sm">
                  <MainText variant="l3-bold">
                    {i18n.t("concrete-example")}
                  </MainText>
                  <ActionText text={contentHow} />
                </Box>
              )}
            </Box>
          </ScrollView>
        </>
      ) : (
        <Box flex={1} overflow="scroll">
          <CommentList />
        </Box>
      )}
      <Box paddingHorizontal="webM">
        <SocialSheet
          contentTitle={contentTitle}
          rating={rating}
          numberOfComments={numberOfComments}
          users={users}
          totalDone={totalDone}
          onPressSocialSheet={handlePressSocialSheet}
          sheetOpen={isOpenSocialSheet}
        />
      </Box>
    </Box>
  );
};

export default Action;
